import { render } from "./RouletteBetElement.vue?vue&type=template&id=4a0f7d1f&scoped=true"
import script from "./RouletteBetElement.vue?vue&type=script&lang=js"
export * from "./RouletteBetElement.vue?vue&type=script&lang=js"

import "./RouletteBetElement.vue?vue&type=style&index=0&id=4a0f7d1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0f7d1f"]])

export default __exports__